import { PaginatedPoi } from './../../shared/models/paginated-poi.model';
import { IPoi } from './poi.model';
import { Injectable } from '@angular/core';
import { dispatch } from '@angular-redux/store';
import { AnyAction } from 'redux';

@Injectable()
export class PoiActionService {

    static POI_LIST = 'POI_LIST';
    static DELETE_POI = 'DELETE_POI';
    static ADD_OR_UPDATE_POI = 'ADD_OR_UPDATE_POI';
    static MODIFY_POI = 'MODIFY_POI';
    static SET_POI_CURRENT = 'SET_POI_CURRENT';
    static RESET_FILTERS = 'RESET_FILTERS';
    static SEARCH_POI = 'SEARCH_POI';
    static PAGINATED_POI_LIST = 'PAGINATED_POI_LIST';

    constructor() {

    }

    @dispatch()
    paginatedPoiList = ( data: PaginatedPoi ): AnyAction => ({ type: PoiActionService.PAGINATED_POI_LIST, payload: data })

    @dispatch()
    poiList = ( data ): AnyAction => ({ type: PoiActionService.POI_LIST, payload: data })

    @dispatch()
    addOrUpdatePoi = ( data: IPoi ): AnyAction => ({ type: PoiActionService.ADD_OR_UPDATE_POI, payload: data })

    @dispatch()
    deletePoi = ( data ): AnyAction => ({ type: PoiActionService.DELETE_POI, payload: data })

    @dispatch()
    modifyPoi = ( data ): AnyAction => ({ type: PoiActionService.MODIFY_POI, payload: data })

    @dispatch()
    setPoiCurrent = ( data ): AnyAction => ({ type: PoiActionService.SET_POI_CURRENT, payload: data })

    @dispatch()
    resetFilters = ( ): AnyAction => ({ type: PoiActionService.RESET_FILTERS })

    @dispatch()
    searchPOI = ( data ): AnyAction => ({ type: PoiActionService.SEARCH_POI, payload: data })
}
